import * as React from "react";
import styled from "styled-components";
import { DogOwnerSavePanel, IDogOwnerSavePanelProps } from "./DogOwnerSavePanel";
import { OwnerSearchPanel } from "./OwnerSearchPanel";
import { PersonGridDto } from "../../../../../../api";
import { Classes, IPanel, PanelStack } from "@blueprintjs/core";
import { ETLCodes } from "../../../../../../locales";
import { useTl } from "../../../../../../hooks";

export interface IDogOwnerPanelStackProps extends Pick<IDogOwnerSavePanelProps, "onSaved"> {
  dogId: number;
  dogBirthDate: Date;
  dogOwnershipId: number;
}

const Container = styled.div`
  flex: 1;
  height: 100%;
  & > .${Classes.PANEL_STACK} {
    height: 100%;
  }
`;

export const DogOwnerPanelStack: React.FunctionComponent<IDogOwnerPanelStackProps> = ({
  dogId,
  onSaved,
  dogBirthDate,
  dogOwnershipId,
}) => {
  const { t } = useTl();
  const onSectionSelected = React.useCallback(
    (data: PersonGridDto) => {
      console.log("data: ", data);
      setPanelStack((currentStack) => [
        ...currentStack,
        {
          component: () => (
            <DogOwnerSavePanel
              onSaved={onSaved}
              person={data}
              dogId={dogId}
              dogBirthDate={dogBirthDate}
              dogOwnershipId={dogOwnershipId}
            />
          ),
        },
      ]);
    },
    [dogBirthDate, dogId, dogOwnershipId, onSaved]
  );

  const [panelStack, setPanelStack] = React.useState<IPanel[]>([
    {
      component: () => <OwnerSearchPanel onPersonSelected={onSectionSelected} dogId={dogId} />,
      title: t(ETLCodes.OwnerSelection),
    },
  ]);

  const removeFromPanelStack = React.useCallback(() => {
    setPanelStack((prev) => prev.slice(0, prev.length - 1));
  }, [setPanelStack]);

  return !dogOwnershipId || dogOwnershipId === 0 ? (
    <Container>
      <PanelStack stack={panelStack} showPanelHeader={true} onClose={removeFromPanelStack} />
    </Container>
  ) : (
    <Container>
      {" "}
      <DogOwnerSavePanel
        onSaved={onSaved}
        person={null}
        dogId={dogId}
        dogBirthDate={dogBirthDate}
        dogOwnershipId={dogOwnershipId}
      />{" "}
    </Container>
  );
};
